// Deprecated. Import from 'metadata.js' directly instead.
export { getCountryCallingCode as default } from './metadata.js';
//# sourceMappingURL=getCountryCallingCode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/es6/getCountryCallingCode.js
// module id = 217
// module chunks = 22